<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="218px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    (nzCollapsedChange)="toggleCollapse($event)">
    <div class="sidebar-logo" [ngClass]="{'expand': !isCollapsed}">
      <img src="assets/images/halo_color.png" alt="logo" *ngIf="!isCollapsed">
      <span *ngIf="!isCollapsed">{{product==='YC'?'数企通':'易享云'}}</span>
      <img src="assets/images/halo_color_s.png" alt="logo" *ngIf="isCollapsed">
    </div>

    <div style="height: calc(100vh - 128px);">
      <ng-scrollbar>
        <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">

          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>

          <ng-template #menuTpl let-menus>
            <ng-container *ngFor="let menu of menus">
              <li *ngIf="!menu.children  && !menu.disabled" nz-menu-item nzMatchRouter
                [nzSelected]="router.url.split('?')[0] === menu.menuUrl || router.url.split('?')[0] === '/dashboard'+menu.menuUrl " [nzPaddingLeft]="menu.level * 30"
                [nzDisabled]="menu.disabled" >
                <a [routerLink]="menu.menuUrl">
                  <i nz-icon *ngIf="menu.icon" [nzIconfont]="menu.icon"></i>
                  <span style="position:relative;bottom:2px">{{ menu.menuName }}</span>
                </a>
              </li>
              <li nz-submenu *ngIf="menu.children && !menu.disabled" [nzPaddingLeft]="menu.level * 30"
              [nzOpen]="activeRouteEx(menu)" [nzDisabled]="menu.disabled">  <!-- [nzOpen]="activeRouteEx(menu.menuUrl)" -->
                <span title>
                  <i nz-icon *ngIf="menu.icon" [nzIconfont]="menu.icon"></i>
                  <span>{{menu.menuName}}</span>
                </span>
                <ul>
                  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>
                </ul>
              </li>

              <!--          <li-->
              <!--            *ngIf="menu.children"-->
              <!--            nz-submenu-->
              <!--            [nzPaddingLeft]="menu.level * 24"-->
              <!--            [nzOpen]="activeRoute(menu.menuUrl)"-->
              <!--            [nzTitle]="menu.menuName"-->
              <!--            [nzIcon]="menu.icon"-->
              <!--            [nzDisabled]="menu.disabled"-->
              <!--          >-->
              <!--            <ul>-->
              <!--              <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>-->
              <!--            </ul>-->
              <!--          </li>-->
            </ng-container>
          </ng-template>

        </ul>
      </ng-scrollbar>
    </div>



  </nz-sider>

  <nz-layout>
    <nz-header>
      <div class="app-header">
        <app-top-nav></app-top-nav>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>